import { Delete } from "lucide-react";
import type { KeypadAction, KeypadDigit } from "@budgeter/shared";

const digits: KeypadDigit[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0"];

/**
 * The implied-decimal amount keypad (SPEC §11.3): 0–9, 00 and backspace. The system keyboard
 * is never shown; pair with `keypadReducer` from @budgeter/shared.
 */
export function Keypad({ dispatch }: { dispatch: (action: KeypadAction) => void }) {
  const key =
    "grid h-[52px] place-items-center rounded-xl bg-surface text-[24px] font-semibold text-ink shadow-[0_1px_0_#E2D6C5] select-none active:bg-chip";
  return (
    <div className="grid grid-cols-3 gap-2" role="group" aria-label="Amount keypad">
      {digits.map((d) => (
        <button
          key={d}
          type="button"
          className={key}
          onClick={() => dispatch({ type: "digit", digit: d })}
        >
          {d}
        </button>
      ))}
      <button
        type="button"
        className={key}
        onClick={() => dispatch({ type: "backspace" })}
        aria-label="Backspace"
      >
        <Delete size={24} aria-hidden />
      </button>
    </div>
  );
}
